import * as React from 'react';
import * as styles from './styles.scss';
import { isTextInputElement, useProjectId } from 'owa-timestream-asset-sdk';
import { useInitializeTasks } from 'owa-timestream-asset-sdk-tasks';
import { observer } from 'mobx-react-lite';
import { useAssetDescriptors } from '../hooks/useAssetDescriptors';
import { useAssetNotifications } from 'owa-timestream-notifications';
import { useLogOpenProject } from '../hooks/useLogOpenProject';
import TimeStreamCanvasDocumentLayer from './TimeStreamCanvasDocumentLayer';
import TimeStreamToolsLayer from './TimeStreamToolsLayer';
import useDisableGestures from 'owa-react-hooks/lib/useDisableGestures';
import useDisableScrollZoomAndNavigation from '../hooks/useDisableScrollZoomAndNavigation';
import usePasteAsset from '../util/usePasteAsset';
import useTouchDragDrop from 'owa-dnd/lib/useTouchDragDrop';
import {
    resetPanAndZoom,
    useCanvasHotKeys,
    useMousePosition,
    deleteSelectedAssets,
    getSelectedAssets,
} from '../viewstate';

export default observer(function TimeStreamCanvasBody() {
    const ref = React.useRef<HTMLDivElement>(null);
    const projectId = useProjectId();
    useTouchDragDrop();
    useDisableScrollZoomAndNavigation(ref);
    useCanvasHotKeys();
    useMousePosition();
    usePasteAsset(ref);
    useAssetDescriptors();
    useInitializeTasks(projectId);
    useLogOpenProject();
    useDisableGestures(ref);
    useAssetNotifications(projectId);

    // Initialize pan and zoom from local storage when a project is loaded.
    // NOTE: the key in the TimeStreamCanvas forces new component instances
    // when we change projects. This also happens only after assets are loaded
    // so we can check the persisted pan and zoom settings against asset bounds.
    React.useEffect(() => {
        resetPanAndZoom(projectId);
    }, [projectId]);

    return (
        <div ref={ref} className={styles.canvasBody} onKeyDown={onKeyDown}>
            <TimeStreamCanvasDocumentLayer />
            <TimeStreamToolsLayer />
        </div>
    );
});

function onKeyDown(e: React.KeyboardEvent) {
    if (e.key == 'Delete' && !isTextInputElement(e.target as HTMLInputElement)) {
        const selectedAssets = getSelectedAssets();
        if (selectedAssets.length == 1 && document.activeElement?.id != selectedAssets[0]) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        deleteSelectedAssets();
    }
}
